
import vFooter from '../../common/footer.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import {getMemberAsset,putForward} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
sum:'',
num: '',
isBtns:false
}
},
components: {
Confirm,
vFooter
},
created(){
let params ={
accessToken : this._wxTool.getAccessToken()
}
getMemberAsset(params).then(res=>{
if(res.code == 0){
console.log(res);
this.sum = res.data.asset

}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
methods: {
btnOk() {


if(this.isBtns){
return
}
console.log(this.isBtns)

if(this.num<1){
this.$vux.toast.text('提现金额必须大于1元', 'middle')
return
}
if(this.num>this.sum){
this.$vux.toast.text('资产余额不足！', 'middle')
return
}
const _this = this
this.$vux.confirm.show({
title:'提示',
content:'确定提现吗？',
onCancel () {
console.log(1)

},
onConfirm () {
_this.$vux.loading.show({
text: '提现中...'
})
console.log(_this.isBtns)
if(_this.isBtns){
return
}
this.isBtns = true
let params={
accessToken : _this._wxTool.getAccessToken(),
money:parseFloat(_this.num).toFixed(2)
}

putForward(params).then(res=>{
console.log(_this.isBtns)
_this.isBtns = false;
_this.$vux.loading.hide();
if(res.code == 0){
console.log(res);

_this.$vux.alert.show({
title: '提示',

content: '已提交提现申请，提现款项将会在24小时内发放到您的微信钱包中，请耐心等待！',
onHide () {
_this.$router.push('/extractRecord')
}
})
}else if(res.code == 'U0005'){
_this.$vux.confirm.show({
title: '提示',
content:'由于您的信息不完整，暂时无法提现！',
confirmText:'马上完善',
cancelText:'下次再说',
content:'请完善个人信息',
onCancel () {
console.log(1)
},
onConfirm () {
_this.$router.push({path:'/personalInfo'})
}
})
}else{
_this.$vux.toast.text(res.msg, 'middle')
}
})
}
})
},
extractAll(e) {
let num = this.sum;
this.num=num
},
}
}



// WEBPACK FOOTER //
// ./src/pages/my/extract/extract.vue